import * as React from 'react';
import { FC, useState } from 'react';
import moment from 'moment';
import { Day as TournamentDay, TournamentProps } from './types';
import Calendar from './Calendar';
import Matches from './Matches';
import Results from './Results';
import { LocalesContext } from './locales';

// Day is chosen according to time zone in browser
const firstDayWithMatches = (days: TournamentDay[]) => {
  const today = moment();
  return days.find((day) => moment(day.date).isSameOrAfter(today, 'day'));
};

const Tournament: FC<TournamentProps> = ({ days, time_zone, results, locales }) => {
  const [selectedDay, setSelectedDay] = useState(firstDayWithMatches(days));

  return (
    <LocalesContext.Provider value={locales}>
      <div className="widget_tournament">
        <Calendar days={days} selectedDay={selectedDay} onSelect={setSelectedDay} />
        <Matches day={selectedDay} timeZone={time_zone} />
        {results ? <Results results={results} /> : null}
      </div>
    </LocalesContext.Provider>
  );
};

const WrappedTournament: FC<TournamentProps> = (props) => <Tournament {...props} />;

export default WrappedTournament;
